/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from 'react';
import { Tabs, Tab } from '@celltrak/ui-components';

import VisitPayloadTab from '../VisitPayloadTab';

import useRejectedTabs from './hooks';

const RejectedTabs = () => {
  const { isLoading, saveRejectedDetails } = useRejectedTabs();

  useEffect(() => {
    saveRejectedDetails();
  }, []);

  return (
    <Tabs activeTab="visitPayload" fullHeight>
      <Tab title="Visit Payload" tabKey="visitPayload" fullHeight>
        <VisitPayloadTab isLoading={isLoading} />
      </Tab>
    </Tabs>
  );
};

export default RejectedTabs;
